// Localização: frontend/src/utils/imageUtils.js (CORRIGIDA)

/**
 * Obtém a URL base da API dependendo do ambiente.
 * NOTE: Remove o '/api' para ser usado na rota estática '/uploads'.
 * @returns {string} A URL base (ex: 'http://localhost:3001' ou 'https://api.higeia.tech').
 */
const getBaseUrl = () => {
    // 1. Prioriza o URL de Produção se estiver definido e não for ambiente de desenvolvimento
    if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_API_BASE_URL_PROD) {
        // Remove o '/api' do final, se existir
        return process.env.REACT_APP_API_BASE_URL_PROD.replace(/\/api$/, '');
    }

    // 2. Caso contrário, usa o URL Local (ou fallback)
    const localUrl = process.env.REACT_APP_API_BASE_URL_LOCAL || 'http://localhost:3001/api';
    
    // Remove o '/api' do final
    return localUrl.replace(/\/api$/, '');
};


/**
 * Obtém a URL completa da imagem do paciente.
 * @param {string | null | undefined} fotoUrl - O caminho ou nome do arquivo da foto vindo do DB (ex: '167888.jpg').
 * @returns {string} A URL completa da imagem ou o caminho do placeholder.
 */
export const getPacienteFotoUrl = (fotoUrl) => {
    
    const PLACEHOLDER_URL = '/images/higeia-avatar-shield.png'; 
    const UPLOADS_BASE_URL = getBaseUrl(); // 🛑 Agora obtém a URL correta e limpa (sem /api)

    if (!fotoUrl) {
        return PLACEHOLDER_URL; 
    }

    const baseUrlClean = UPLOADS_BASE_URL.replace(/\/$/, '');
    const urlPathClean = String(fotoUrl).replace(/^\//, '');

    // 3. Checa se já é uma URL absoluta (não precisa de concatenação)
    if (urlPathClean.toLowerCase().startsWith('http')) {
         return urlPathClean; 
    }

    // 4. Concatenação com o Padrão do Backend (uploads/)
    let finalUrl;
    if (urlPathClean.toLowerCase().startsWith('uploads/')) {
        // Ex: http://localhost:3001/uploads/nome.jpg
        finalUrl = `${baseUrlClean}/${urlPathClean}`;
    } else {
        // Ex: http://localhost:3001/uploads/nome.jpg
        finalUrl = `${baseUrlClean}/uploads/${urlPathClean}`;
    }
    
    // Debug removido para evitar poluição do console
    
    return finalUrl;
};

/**
 * Obtém a URL completa da imagem do usuário/profissional.
 * @param {string | null | undefined} fotoUrl - O caminho ou nome do arquivo da foto vindo do DB (ex: '167888.jpg').
 * @returns {string} A URL completa da imagem ou o caminho do placeholder.
 */
export const getUsuarioFotoUrl = (fotoUrl) => {
    const PLACEHOLDER_URL = '/images/higeia-avatar-shield.png'; 
    const UPLOADS_BASE_URL = getBaseUrl();

    if (!fotoUrl) {
        return PLACEHOLDER_URL; 
    }

    const baseUrlClean = UPLOADS_BASE_URL.replace(/\/$/, '');
    const urlPathClean = String(fotoUrl).replace(/^\//, '');

    // Checa se já é uma URL absoluta
    if (urlPathClean.toLowerCase().startsWith('http')) {
         return urlPathClean; 
    }

    // Concatenação com o Padrão do Backend (uploads/)
    let finalUrl;
    if (urlPathClean.toLowerCase().startsWith('uploads/')) {
        finalUrl = `${baseUrlClean}/${urlPathClean}`;
    } else {
        finalUrl = `${baseUrlClean}/uploads/${urlPathClean}`;
    }
    
    // Debug removido para evitar poluição do console
    
    return finalUrl;
};